import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { Search } from '#src/components/team/Search/index.tsx';
import type { PageParams } from '#src/pages/teams/$slug/__generated__/routeParams.ts';

import type {
  NbaTeamCardQuery,
  NbaTeamCardQueryVariables,
} from './__generated__/page.graphql.ts';

const NBA_TEAM_CARD_QUERY = gql`
  query NbaTeamCardQuery($slug: String!) {
    team(slug: $slug) {
      slug
      name
      ...NBATeamSearch_team
    }
  }
  ${Search.fragments.team}
` as TypedDocumentNode<NbaTeamCardQuery, NbaTeamCardQueryVariables>;

const Cards = () => {
  const { slug } = useTypedParams<PageParams>();
  const { data, loading } = useQuery(NBA_TEAM_CARD_QUERY, {
    variables: {
      slug,
    },
  });

  const team = data?.team;
  if (loading) return <LoadingIndicator fullHeight />;
  if (!team) return null;

  return <Search team={team} />;
};

export default Cards;
